import React from "react";
import { xVersion } from "../services/config";

export const fixOutcomeIcon = [
  {
    id: 1,
    path: "M12.0621 0.659249L14.5435 5.67764C14.716 6.02667 15.0496 6.26852 15.4356 6.3244L20.9842 7.12919C21.9562 7.27027 22.344 8.46212 21.6409 9.14599L17.6259 13.0522C17.3469 13.3239 17.2194 13.7155 17.2854 14.0989L18.2331 19.6147C18.3992 20.5807 17.3832 21.3173 16.514 20.8615L11.5514 18.2575C11.2063 18.0766 10.7937 18.0766 10.4486 18.2575L5.48597 20.8615C4.61679 21.3177 3.60077 20.5807 3.76689 19.6147L4.71454 14.0989C4.78062 13.7155 4.65305 13.3239 4.37403 13.0522L0.359033 9.14599C-0.344016 8.46166 0.0437626 7.26982 1.01573 7.12919L6.5644 6.3244C6.95034 6.26852 7.28397 6.02667 7.45652 5.67764L9.93784 0.659249C10.372 -0.219748 11.6275 -0.219748 12.0621 0.659249Z",
  },
  {
    id: 2,
    path: "M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z",
  },
  {
    id: 3,
    path: "M10,2C8.18,2 6.47,2.5 5,3.35C8,5.08 10,8.3 10,12C10,15.7 8,18.92 5,20.65C6.47,21.5 8.18,22 10,22A10,10 0 0,0 20,12A10,10 0 0,0 10,2Z",
  },
  {
    id: 4,
    path: "M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22 2 17.5 2 12 6.5 2 12 2M12 4C10.1 4 8.4 4.6 7.1 5.7L18.3 16.9C19.3 15.5 20 13.8 20 12C20 7.6 16.4 4 12 4M16.9 18.3L5.7 7.1C4.6 8.4 4 10.1 4 12C4 16.4 7.6 20 12 20C13.9 20 15.6 19.4 16.9 18.3Z",
  },
  {
    id: 5,
    path: "M2 13.3364C1.99969 10.8887 3.77168 8.80077 6.18683 8.40302C7.52395 6.02105 10.179 4.69598 12.8863 5.05951C15.5937 5.42304 17.8051 7.40159 18.4665 10.0519C20.6196 10.3828 22.1543 12.3164 21.9876 14.4884C21.8209 16.6603 20.0091 18.3372 17.8308 18.3356H6.9992C4.23822 18.3356 2 16.0974 2 13.3364Z",
  },
  {
    id: 6,
    path: "M13.16,12.74L14,14H12.5C12.35,16.71 12,19.41 11.5,22.08L10.5,21.92C11,19.3 11.34,16.66 11.5,14H10L10.84,12.74C8.64,11.79 7,8.36 7,6A5,5 0 0,1 12,1A5,5 0 0,1 17,6C17,8.36 15.36,11.79 13.16,12.74Z",
  },
  {
    id: 7,
    path: "M1.2234 2.21444C1.18666 2.32606 1.16422 2.43218 1.14944 2.52602C1.11533 2.74261 1.10915 2.99405 1.104 3.20343L1.07471 4.3645C0.994408 7.54599 0.931247 10.0482 1.14861 12.0002C1.37146 14.0013 1.90446 15.5986 3.15291 16.8471C4.40137 18.0955 5.99871 18.6285 7.99983 18.8514C9.95179 19.0688 12.454 19.0056 15.6355 18.9253L16.7965 18.896C17.0059 18.8909 17.2574 18.8847 17.474 18.8506C17.7365 18.8092 18.0951 18.7079 18.4015 18.4015C18.7079 18.0951 18.8092 17.7365 18.8506 17.474C18.8847 17.2574 18.8909 17.0059 18.896 16.7965L18.9253 15.6355C19.0056 12.454 19.0688 9.95179 18.8514 7.99983C18.6285 5.99871 18.0955 4.40137 16.8471 3.15291C15.5986 1.90446 14.0013 1.37146 12.0002 1.14861C10.0482 0.931248 7.54602 0.994407 4.36455 1.07471L3.271 1.10229C3.53505 1.26777 3.8038 1.4425 4.07478 1.62455C5.83262 2.80552 7.75984 4.34562 9.20711 5.79289C9.24689 5.83267 9.28647 5.87257 9.32586 5.91257L12.6049 5.03395C13.1384 4.89101 13.6867 5.20759 13.8296 5.74106C13.9726 6.27453 13.656 6.82286 13.1225 6.96581L10.8241 7.58166C11.5616 8.47714 12.1901 9.35173 12.6863 10.0918C13.1017 10.7114 13.428 11.2421 13.6514 11.6197C13.7632 11.8087 13.8495 11.9596 13.9084 12.0646C13.9379 12.1171 13.9606 12.1582 13.9763 12.1868L13.9945 12.2202L13.9997 12.2297L14.0012 12.2326L14.0017 12.2335C14.2627 12.7203 14.08 13.3271 13.5933 13.588C13.1067 13.8489 12.5007 13.6661 12.2396 13.1796L12.2363 13.1734L12.2227 13.1485C12.2102 13.1256 12.1908 13.0905 12.1647 13.0441C12.1125 12.9512 12.0338 12.8133 11.9301 12.6381C11.7228 12.2876 11.4165 11.7893 11.0252 11.2056C10.3586 10.2114 9.45527 8.98487 8.38334 7.82246C8.30249 7.75923 8.231 7.68335 8.17226 7.59675C8.04789 7.46564 7.9214 7.33562 7.79289 7.20711C7.54389 6.9581 7.27823 6.70497 7 6.45064V10.5C7 11.0523 6.55228 11.5 6 11.5C5.44772 11.5 5 11.0523 5 10.5V4.76696C4.32256 4.23824 3.62876 3.73435 2.95946 3.28469C2.33882 2.86773 1.74969 2.50447 1.2234 2.21444Z",
  },
  {
    id: 8,
    path: "M3.0124 11.4782L9.42661 17.4648L9.42663 17.4649C9.64511 17.6688 9.75435 17.7707 9.88126 17.8018C9.95927 17.8208 10.0407 17.8208 10.1187 17.8018C10.2456 17.7707 10.3549 17.6688 10.5734 17.4649L10.5734 17.4648L16.9876 11.4782C18.7233 9.85823 19.0255 7.21748 17.7007 5.2472L17.4445 4.8662C15.7015 2.274 11.8006 2.56059 10.4552 5.37968C10.2725 5.76249 9.72755 5.76249 9.54485 5.37968C8.19937 2.56059 4.29852 2.274 2.55549 4.86619L2.2993 5.2472C0.974454 7.21748 1.27667 9.85823 3.0124 11.4782Z",
  },
];

export const commanColorPalette = [
  {
    color: "#E57C73",
    text: "Struggling to cope",
    isSelected: true,
  },
  {
    color: "#F3AB6D",
    text: "Irritated and frustrated",
    isSelected: false,
  },

  {
    color: "#F7D966",
    text: "Good day with some reasonable progress",
    isSelected: false,
  },
  {
    color: "#ABCA79",
    text: "Slow day with nothing standing out",
    isSelected: false,
  },
  {
    color: "#ADE888",
    text: "Awesome day, feeling in control",
    isSelected: false,
  },
];

export const IDWiseColorPalette = [
  {
    name: "Neutral",
    ids: [7, 6, 4]
  },
  {
    name: "Positive",
    ids: [5]
  },
  {
    name: "Negative",
    ids: [3]
  },
  {
    name: "Reversed",
    ids: [2]
  },
  {
    name: "Standard",
    ids: [1]
  }
]

export const fixOutcomeColorPalette = [
  {
    id: 1,
    color: ["#FF5555", "#FFB378", "#F7D257", "#CDE675", "#ADE888"],
  },
  {
    id: 2,
    color: ["#ADE888", "#CDE675", "#F7D257", "#FFB378", "#FF5555"],
  },
  {
    id: 3,
    color: ["#FFC6C6", "#E67F7F", "#DE5454", "#AB2121", "#801919"],
  },
  {
    id: 4,
    color: ["#FFC599", "#FFA866", "#FF8B33", "#CC5800", "#994200"],
  },
  {
    id: 5,
    color: ["#C4EEAA", "#A6E67F", "#89DE54", "#56AB21", "#408019"],
  },
  {
    id: 6,
    color: ["#A3CCF5", "#76B2EF", "#4899EA", "#1566B7", "#104C89"],
  },
  {
    id: 7,
    color: ["#C7ADEB", "#AB84E1", "#8F5BD7", "#5C28A4", "#451E7B"],
  },
];

export const OutcomeStatus = [
  { text: "very low" },
  { text: "low" },
  { text: "medium" },
  { text: "high" },
  { text: "very high" },
];

export const NewGoalsSteps = [
  "Your goals",
  "Your focus",
  "Your plan",
  "Tracking",
];

export const UserStepper = ["Add outcomes", "Add Influences", "Tracking"];

export const GoalStepper = [
  "Add goals for outcome and influence",
  "Add goals for reflective question",
  "",
];

export const ProUserStepper = [
  "Add outcomes",
  "Add Influences",
  "Qualitative Reflection",
  "Tracking",
];

export const InfluenceSelectOption = [
  {
    value: "Custom",
    id: "TYPE1",
  },
  { value: "5-point scale", id: "TYPE2" },
  { value: "Yes/no scale", id: "TYPE3" },
];

export const InfluenceSelectOptionMobile = [
  { value: "5 point", id: "TYPE2" },
  { value: "Yes/No", id: "TYPE3" },
  {
    value: "Custom",
    id: "TYPE1",
  },
];

export const MeasurementUnit = [
  { value: "hours", id: "hours" },
  { value: "minutes", id: "Min" },
  { value: "seconds", id: "S" },
  { value: "mili-meter", id: "MM" },
  { value: "meter", id: "M" },
  { value: "centi-meter", id: "CM" },
  { value: "kilo-meter", id: "KM" },
  { value: "mili-liter", id: "ML" },
  { value: "liter", id: "L" },
  { value: "mili-gram", id: "MG" },
  { value: "gram", id: "G" },
  { value: "kilogram", id: "KG" },
  { value: "time of day", id: "timeofday" },
  { value: "percentage(%)", id: "percentage" },
  { value: "times", id: "times" },
  { value: "points", id: "points" },
  { value: "millisecond", id: "ms" },
  { value: "kilocalories", id: "KCAL" },
  { value: "beats/min", id: "bpm" },
  { value: "celsius", id: "C" },
  { value: "kilojoule", id: "kilojoule" },
  { value: "cal", id: "cal" },
];

export const SidebarBottomItems = [
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.1875 8.4375C7.1875 8.18886 7.28627 7.9504 7.46209 7.77459C7.6379 7.59877 7.87636 7.5 8.125 7.5H13.75C13.9986 7.5 14.2371 7.59877 14.4129 7.77459C14.5887 7.9504 14.6875 8.18886 14.6875 8.4375C14.6875 8.68614 14.5887 8.9246 14.4129 9.10041C14.2371 9.27623 13.9986 9.375 13.75 9.375H8.125C7.87636 9.375 7.6379 9.27623 7.46209 9.10041C7.28627 8.9246 7.1875 8.68614 7.1875 8.4375ZM8.125 12.5H13.75C13.9986 12.5 14.2371 12.4012 14.4129 12.2254C14.5887 12.0496 14.6875 11.8111 14.6875 11.5625C14.6875 11.3139 14.5887 11.0754 14.4129 10.8996C14.2371 10.7238 13.9986 10.625 13.75 10.625H8.125C7.87636 10.625 7.6379 10.7238 7.46209 10.8996C7.28627 11.0754 7.1875 11.3139 7.1875 11.5625C7.1875 11.8111 7.28627 12.0496 7.46209 12.2254C7.6379 12.4012 7.87636 12.5 8.125 12.5ZM18.4375 5V14.375C18.4375 14.6623 18.3809 14.9467 18.271 15.2121C18.1611 15.4775 17.9999 15.7187 17.7968 15.9218C17.5937 16.1249 17.3525 16.2861 17.0871 16.396C16.8217 16.5059 16.5373 16.5625 16.25 16.5625H2.8125C2.14946 16.5625 1.51357 16.2991 1.04473 15.8303C0.575892 15.3614 0.3125 14.7255 0.3125 14.0625V6.875C0.3125 6.62636 0.411272 6.3879 0.587087 6.21209C0.762903 6.03627 1.00136 5.9375 1.25 5.9375C1.49864 5.9375 1.7371 6.03627 1.91291 6.21209C2.08873 6.3879 2.1875 6.62636 2.1875 6.875V14.0625C2.1875 14.2283 2.25335 14.3872 2.37056 14.5044C2.48777 14.6217 2.64674 14.6875 2.8125 14.6875C2.97826 14.6875 3.13723 14.6217 3.25444 14.5044C3.37165 14.3872 3.4375 14.2283 3.4375 14.0625V5C3.4375 4.5856 3.60212 4.18817 3.89515 3.89515C4.18817 3.60212 4.5856 3.4375 5 3.4375H16.875C17.2894 3.4375 17.6868 3.60212 17.9799 3.89515C18.2729 4.18817 18.4375 4.5856 18.4375 5ZM16.5625 5.3125H5.3125V14.0625C5.31291 14.2733 5.28666 14.4833 5.23438 14.6875H16.25C16.3329 14.6875 16.4124 14.6546 16.471 14.596C16.5296 14.5374 16.5625 14.4579 16.5625 14.375V5.3125Z" fill="#656565" />
      </svg>

    ),
    text: "Blog",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.25 14.0625C11.25 14.3097 11.1767 14.5514 11.0393 14.757C10.902 14.9625 10.7068 15.1227 10.4784 15.2174C10.25 15.312 9.99862 15.3367 9.75614 15.2885C9.51366 15.2403 9.29094 15.1212 9.11612 14.9464C8.9413 14.7716 8.82225 14.5488 8.77402 14.3064C8.72579 14.0639 8.75054 13.8126 8.84515 13.5841C8.93976 13.3557 9.09998 13.1605 9.30554 13.0232C9.5111 12.8858 9.75278 12.8125 10 12.8125C10.3315 12.8125 10.6495 12.9442 10.8839 13.1786C11.1183 13.413 11.25 13.731 11.25 14.0625ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31038 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10ZM10 5C8.10469 5 6.5625 6.40156 6.5625 8.125V8.4375C6.5625 8.68614 6.66128 8.9246 6.83709 9.10041C7.01291 9.27623 7.25136 9.375 7.5 9.375C7.74864 9.375 7.9871 9.27623 8.16292 9.10041C8.33873 8.9246 8.4375 8.68614 8.4375 8.4375V8.125C8.4375 7.43594 9.14063 6.875 10 6.875C10.8594 6.875 11.5625 7.43594 11.5625 8.125C11.5625 8.81406 10.8594 9.375 10 9.375C9.75136 9.375 9.51291 9.47377 9.33709 9.64959C9.16128 9.8254 9.0625 10.0639 9.0625 10.3125V10.9375C9.06194 11.1691 9.14715 11.3927 9.30169 11.5653C9.45623 11.7378 9.66916 11.847 9.89945 11.8719C10.1297 11.8967 10.3611 11.8354 10.5488 11.6998C10.7366 11.5642 10.8676 11.3639 10.9164 11.1375C12.368 10.7719 13.4375 9.56016 13.4375 8.125C13.4375 6.40156 11.8953 5 10 5Z" fill="#656565" />
      </svg>

    ),
    text: "FAQ",
    route: "/faq",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.6875 16.875C9.6875 17.1236 9.58873 17.3621 9.41291 17.5379C9.2371 17.7137 8.99864 17.8125 8.75 17.8125H3.75C3.50136 17.8125 3.2629 17.7137 3.08709 17.5379C2.91127 17.3621 2.8125 17.1236 2.8125 16.875V3.125C2.8125 2.87636 2.91127 2.6379 3.08709 2.46209C3.2629 2.28627 3.50136 2.1875 3.75 2.1875H8.75C8.99864 2.1875 9.2371 2.28627 9.41291 2.46209C9.58873 2.6379 9.6875 2.87636 9.6875 3.125C9.6875 3.37364 9.58873 3.6121 9.41291 3.78791C9.2371 3.96373 8.99864 4.0625 8.75 4.0625H4.6875V15.9375H8.75C8.99864 15.9375 9.2371 16.0363 9.41291 16.2121C9.58873 16.3879 9.6875 16.6264 9.6875 16.875ZM18.1633 9.33672L15.0383 6.21172C14.8622 6.0356 14.6233 5.93665 14.3742 5.93665C14.1251 5.93665 13.8863 6.0356 13.7102 6.21172C13.534 6.38784 13.4351 6.62671 13.4351 6.87578C13.4351 7.12485 13.534 7.36372 13.7102 7.53984L15.2344 9.0625H8.75C8.50136 9.0625 8.2629 9.16127 8.08709 9.33709C7.91127 9.5129 7.8125 9.75136 7.8125 10C7.8125 10.2486 7.91127 10.4871 8.08709 10.6629C8.2629 10.8387 8.50136 10.9375 8.75 10.9375H15.2344L13.7094 12.4617C13.5333 12.6378 13.4343 12.8767 13.4343 13.1258C13.4343 13.3749 13.5333 13.6137 13.7094 13.7898C13.8855 13.966 14.1244 14.0649 14.3734 14.0649C14.6225 14.0649 14.8614 13.966 15.0375 13.7898L18.1625 10.6648C18.2499 10.5778 18.3194 10.4743 18.3667 10.3604C18.4141 10.2465 18.4386 10.1243 18.4386 10.0009C18.4387 9.87755 18.4144 9.75537 18.3672 9.64138C18.3199 9.5274 18.2506 9.42387 18.1633 9.33672Z" fill="#656565" />
      </svg>

    ),
    text: "Logout",
    route: "/login",
  },
];

export const SideBarItems = [
  // {
  //   icon: (
  //     <svg
  //       style={{ zIndex: 1 }}
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="18"
  //       height="16"
  //       viewBox="0 0 18 16"
  //       fill="none"
  //     >
  //       <path
  //         d="M5 1H18V3H5V1ZM0 0.5H3V3.5H0V0.5ZM0 6.5H3V9.5H0V6.5ZM0 12.5H3V15.5H0V12.5ZM5 7H18V9H5V7ZM5 13H18V15H5V13Z"
  //         fill="#B7BDB9"
  //       />
  //     </svg>
  //   ),
  //   text: "TestGoals",
  //   route: "/test-goals",
  // },
  {
    icon: (color = "black") => (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.1633 4.33677L15.6633 1.83677C15.5762 1.74937 15.4727 1.68003 15.3587 1.63271C15.2448 1.58539 15.1226 1.56104 14.9992 1.56104C14.8758 1.56104 14.7537 1.58539 14.6397 1.63271C14.5257 1.68003 14.4223 1.74937 14.3352 1.83677L6.83516 9.33677C6.65996 9.513 6.56189 9.75156 6.5625 10.0001V12.5001C6.5625 12.7487 6.66127 12.9872 6.83709 13.163C7.0129 13.3388 7.25136 13.4376 7.5 13.4376H10C10.1231 13.4377 10.2451 13.4135 10.3589 13.3664C10.4727 13.3194 10.5762 13.2504 10.6633 13.1633L18.1633 5.66334C18.2504 5.57627 18.3196 5.47287 18.3668 5.35906C18.414 5.24525 18.4382 5.12326 18.4382 5.00006C18.4382 4.87685 18.414 4.75486 18.3668 4.64105C18.3196 4.52724 18.2504 4.42384 18.1633 4.33677ZM15 3.82818L16.1719 5.00006L15.3125 5.85943L14.1406 4.68756L15 3.82818ZM9.60937 11.5626H8.4375V10.3907L12.8125 6.01568L13.9844 7.18756L9.60937 11.5626ZM17.8125 10.9821V16.2501C17.8125 16.6645 17.6479 17.0619 17.3549 17.3549C17.0618 17.6479 16.6644 17.8126 16.25 17.8126H3.75C3.3356 17.8126 2.93817 17.6479 2.64515 17.3549C2.35212 17.0619 2.1875 16.6645 2.1875 16.2501V3.75006C2.1875 3.33565 2.35212 2.93823 2.64515 2.6452C2.93817 2.35218 3.3356 2.18756 3.75 2.18756H9.01797C9.26661 2.18756 9.50507 2.28633 9.68088 2.46214C9.8567 2.63796 9.95547 2.87642 9.95547 3.12506C9.95547 3.3737 9.8567 3.61215 9.68088 3.78797C9.50507 3.96378 9.26661 4.06256 9.01797 4.06256H4.0625V15.9376H15.9375V10.9821C15.9375 10.7334 16.0363 10.495 16.2121 10.3192C16.3879 10.1434 16.6264 10.0446 16.875 10.0446C17.1236 10.0446 17.3621 10.1434 17.5379 10.3192C17.7137 10.495 17.8125 10.7334 17.8125 10.9821Z" fill="#656565" />
      </svg>
    ),
    text: "Tracking",
    route: "/tracking",
    children: ["/version"],
  },
  !xVersion && {
    icon: (color = "black") => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
      >
        <path
          d="M10.8336 4.29169L7.6669 7.50783C7.61003 7.56559 7.58127 7.59454 7.55582 7.61732C7.1445 7.98548 6.52252 7.98549 6.1112 7.61733C6.08573 7.59454 6.05676 7.56562 5.99986 7.50783C5.94296 7.45004 5.91449 7.42113 5.88903 7.39834C5.47771 7.03018 4.85547 7.03018 4.44415 7.39834C4.41875 7.42107 4.39037 7.44989 4.33375 7.5074L2.16666 9.70835M10.8336 4.29169L10.8333 7.54169M10.8336 4.29169H7.58332"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    text: "Progress",
    route: "/progress",
  },
 
  // {
  //   icon: (color = "black") => (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="13"
  //       height="14"
  //       viewBox="0 0 13 14"
  //       fill="none"
  //     >
  //       <path
  //         d="M4.875 11.875H8.125M6.5 2.125C4.70507 2.125 3.25 3.58007 3.25 5.375C3.25 6.03285 3.44546 6.64506 3.78147 7.1567C4.29817 7.94349 4.55629 8.33663 4.58982 8.39538C4.88815 8.91805 4.83322 8.73371 4.87077 9.33435C4.87499 9.40187 4.875 9.50407 4.875 9.70833C4.875 10.0075 5.11751 10.25 5.41667 10.25L7.58333 10.25C7.88249 10.25 8.125 10.0075 8.125 9.70833C8.125 9.50406 8.125 9.40187 8.12922 9.33435C8.16677 8.73371 8.11152 8.91805 8.40985 8.39538C8.44339 8.33663 8.70195 7.94349 9.21865 7.1567C9.55466 6.64506 9.75011 6.03285 9.75011 5.375C9.75011 3.58007 8.29493 2.125 6.5 2.125Z"
  //         stroke={color}
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //     </svg>
  //   ),
  //   text: "Insights",
  //   route: "/insights",
  // },
  {
    icon: (color = "black") => (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 15.3125H17.1875V3.125C17.1875 2.87636 17.0887 2.6379 16.9129 2.46209C16.7371 2.28627 16.4986 2.1875 16.25 2.1875H11.875C11.6264 2.1875 11.3879 2.28627 11.2121 2.46209C11.0363 2.6379 10.9375 2.87636 10.9375 3.125V5.9375H7.5C7.25136 5.9375 7.0129 6.03627 6.83709 6.21209C6.66127 6.3879 6.5625 6.62636 6.5625 6.875V9.6875H3.75C3.50136 9.6875 3.2629 9.78627 3.08709 9.96209C2.91127 10.1379 2.8125 10.3764 2.8125 10.625V15.3125H2.5C2.25136 15.3125 2.0129 15.4113 1.83709 15.5871C1.66127 15.7629 1.5625 16.0014 1.5625 16.25C1.5625 16.4986 1.66127 16.7371 1.83709 16.9129C2.0129 17.0887 2.25136 17.1875 2.5 17.1875H17.5C17.7486 17.1875 17.9871 17.0887 18.1629 16.9129C18.3387 16.7371 18.4375 16.4986 18.4375 16.25C18.4375 16.0014 18.3387 15.7629 18.1629 15.5871C17.9871 15.4113 17.7486 15.3125 17.5 15.3125ZM12.8125 4.0625H15.3125V15.3125H12.8125V4.0625ZM8.4375 7.8125H10.9375V15.3125H8.4375V7.8125ZM4.6875 11.5625H6.5625V15.3125H4.6875V11.5625Z" fill="#656565" />
      </svg>
    ),
    text: "Progress",
    route: "/insight-progress",
  },
  // {
  //   icon: (
  //     <svg
  //       style={{ zIndex: 1 }}
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="16"
  //       height="20"
  //       viewBox="0 0 16 20"
  //       fill="none"
  //     >
  //       <path
  //         d="M14 20H2C0.89543 20 0 19.1046 0 18V2C0 0.89543 0.89543 0 2 0H11C11.0109 0.000472319 11.0217 0.00249256 11.032 0.006C11.0418 0.00901724 11.0518 0.0110277 11.062 0.012C11.1502 0.0176532 11.2373 0.0347982 11.321 0.063L11.349 0.072C11.3717 0.079682 11.3937 0.0890412 11.415 0.1C11.5239 0.148424 11.6232 0.216185 11.708 0.3L15.708 4.3C15.7918 4.38479 15.8596 4.48406 15.908 4.593C15.918 4.615 15.925 4.638 15.933 4.661L15.942 4.687C15.9699 4.77039 15.9864 4.85718 15.991 4.945C15.9926 4.95418 15.9949 4.96322 15.998 4.972C15.9998 4.98122 16.0004 4.99062 16.0001 5V18C16.0001 19.1046 15.1046 20 14 20ZM2 2V18H14V7H10C9.44772 7 9 6.55228 9 6V2H2ZM11 2.414V5H13.586L11 2.414Z"
  //         fill="#B7BDB9"
  //       />
  //     </svg>
  //   ),
  //   text: "Learn More",
  //   route: "/learn-more",
  // },
  // {
  //   icon: (
  //     <svg
  //       style={{ zIndex: 1 }}
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="20"
  //       height="19"
  //       viewBox="0 0 20 19"
  //       fill="none"
  //     >
  //       <path
  //         d="M18 18.0009H2C0.930516 18.0329 0.0364164 17.1943 0 16.1249V1.87592C0.0364132 0.806725 0.930683 -0.0316533 2 0.000917777H18C19.0693 -0.0316533 19.9636 0.806725 20 1.87592V16.1259C19.963 17.1949 19.0691 18.0329 18 18.0009ZM2 2.00092V15.9899L18 16.0009V2.01192L2 2.00092ZM11.43 13.0009H4C4.07353 12.173 4.46534 11.4058 5.093 10.8609C5.79183 10.1676 6.73081 9.77012 7.715 9.75092C8.69919 9.77012 9.63817 10.1676 10.337 10.8609C10.9645 11.406 11.3563 12.173 11.43 13.0009ZM16 12.0009H13V10.0009H16V12.0009ZM7.715 9.00092C7.17907 9.01954 6.65947 8.81481 6.28029 8.43563C5.9011 8.05644 5.69638 7.53684 5.715 7.00092C5.69668 6.46508 5.9015 5.94565 6.28062 5.56654C6.65974 5.18742 7.17916 4.98259 7.715 5.00092C8.25084 4.98259 8.77026 5.18742 9.14938 5.56654C9.5285 5.94565 9.73332 6.46508 9.715 7.00092C9.73362 7.53684 9.5289 8.05644 9.14971 8.43563C8.77053 8.81481 8.25093 9.01954 7.715 9.00092ZM16 8.00092H12V6.00092H16V8.00092Z"
  //         fill="#B7BDB9"
  //       />
  //     </svg>
  //   ),
  //   text: "Get a coach",
  //   route: "/coach",
  // },

  {
    icon: (color = "black") => (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.2273 15.4641C17.5485 15.048 17.7466 14.5502 17.7992 14.0272C17.8518 13.5043 17.7568 12.977 17.525 12.5053C17.2931 12.0336 16.9338 11.6363 16.4876 11.3584C16.0415 11.0805 15.5264 10.9333 15.0008 10.9333C14.4752 10.9333 13.9601 11.0805 13.5139 11.3584C13.0678 11.6363 12.7084 12.0336 12.4766 12.5053C12.2448 12.977 12.1498 13.5043 12.2024 14.0272C12.255 14.5502 12.4531 15.048 12.7742 15.4641C12.1986 15.9208 11.7854 16.5509 11.5961 17.2609C11.5325 17.5012 11.5668 17.7569 11.6917 17.9718C11.8165 18.1867 12.0215 18.3432 12.2617 18.407C12.3395 18.4276 12.4196 18.4378 12.5 18.4375C12.7066 18.4374 12.9074 18.369 13.0712 18.2429C13.2349 18.1169 13.3524 17.9403 13.4055 17.7406C13.5938 17.0469 14.2461 16.5625 15 16.5625C15.7539 16.5625 16.4062 17.0469 16.5938 17.7406C16.6609 17.9773 16.8183 18.178 17.0321 18.2997C17.246 18.4213 17.499 18.454 17.7367 18.3907C17.9744 18.3275 18.1777 18.1734 18.3028 17.9616C18.4279 17.7498 18.4648 17.4973 18.4055 17.2586C18.2159 16.5493 17.8028 15.92 17.2273 15.4641ZM15 12.8125C15.1854 12.8125 15.3667 12.8675 15.5208 12.9705C15.675 13.0735 15.7952 13.2199 15.8661 13.3912C15.9371 13.5625 15.9557 13.751 15.9195 13.9329C15.8833 14.1148 15.794 14.2818 15.6629 14.4129C15.5318 14.544 15.3648 14.6333 15.1829 14.6695C15.001 14.7057 14.8125 14.6871 14.6412 14.6161C14.4699 14.5452 14.3235 14.425 14.2205 14.2708C14.1175 14.1167 14.0625 13.9354 14.0625 13.75C14.0625 13.5014 14.1613 13.2629 14.3371 13.0871C14.5129 12.9113 14.7514 12.8125 15 12.8125ZM16.875 5.3125H10.4211L8.38984 3.02422C8.24295 2.85903 8.06268 2.72689 7.86094 2.63652C7.6592 2.54615 7.44059 2.49962 7.21953 2.5H3.125C2.7106 2.5 2.31317 2.66462 2.02015 2.95765C1.72712 3.25067 1.5625 3.6481 1.5625 4.0625V15.6727C1.56291 16.0742 1.72254 16.4591 2.00637 16.7431C2.2902 17.0271 2.67506 17.1869 3.07656 17.1875H8.79375C9.04239 17.1875 9.28085 17.0887 9.45666 16.9129C9.63248 16.7371 9.73125 16.4986 9.73125 16.25C9.73125 16.0014 9.63248 15.7629 9.45666 15.5871C9.28085 15.4113 9.04239 15.3125 8.79375 15.3125H3.4375V7.1875H16.5625V8.4375C16.5625 8.68614 16.6613 8.9246 16.8371 9.10042C17.0129 9.27623 17.2514 9.375 17.5 9.375C17.7486 9.375 17.9871 9.27623 18.1629 9.10042C18.3387 8.9246 18.4375 8.68614 18.4375 8.4375V6.875C18.4375 6.4606 18.2729 6.06317 17.9799 5.77015C17.6868 5.47712 17.2894 5.3125 16.875 5.3125ZM3.4375 5.3125V4.375H7.07891L7.9125 5.3125H3.4375Z" fill="#656565" />
      </svg>
    ),
    text: "Personal structure",
    route: "/add-category",
  },
  {
    icon: (color = "black") => (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.4375 9.6875C13.4375 9.93614 13.3387 10.1746 13.1629 10.3504C12.9871 10.5262 12.7486 10.625 12.5 10.625H7.5C7.25136 10.625 7.0129 10.5262 6.83709 10.3504C6.66127 10.1746 6.5625 9.93614 6.5625 9.6875C6.5625 9.43886 6.66127 9.2004 6.83709 9.02459C7.0129 8.84877 7.25136 8.75 7.5 8.75H12.5C12.7486 8.75 12.9871 8.84877 13.1629 9.02459C13.3387 9.2004 13.4375 9.43886 13.4375 9.6875ZM12.5 11.875H7.5C7.25136 11.875 7.0129 11.9738 6.83709 12.1496C6.66127 12.3254 6.5625 12.5639 6.5625 12.8125C6.5625 13.0611 6.66127 13.2996 6.83709 13.4754C7.0129 13.6512 7.25136 13.75 7.5 13.75H12.5C12.7486 13.75 12.9871 13.6512 13.1629 13.4754C13.3387 13.2996 13.4375 13.0611 13.4375 12.8125C13.4375 12.5639 13.3387 12.3254 13.1629 12.1496C12.9871 11.9738 12.7486 11.875 12.5 11.875ZM17.1875 3.125V15.625C17.1875 16.3709 16.8912 17.0863 16.3637 17.6137C15.8363 18.1412 15.1209 18.4375 14.375 18.4375H5.625C4.87908 18.4375 4.16371 18.1412 3.63626 17.6137C3.10882 17.0863 2.8125 16.3709 2.8125 15.625V3.125C2.8125 2.87636 2.91127 2.6379 3.08709 2.46209C3.2629 2.28627 3.50136 2.1875 3.75 2.1875H5.625V1.875C5.625 1.62636 5.72377 1.3879 5.89959 1.21209C6.0754 1.03627 6.31386 0.9375 6.5625 0.9375C6.81114 0.9375 7.0496 1.03627 7.22541 1.21209C7.40123 1.3879 7.5 1.62636 7.5 1.875V2.1875H9.0625V1.875C9.0625 1.62636 9.16127 1.3879 9.33709 1.21209C9.5129 1.03627 9.75136 0.9375 10 0.9375C10.2486 0.9375 10.4871 1.03627 10.6629 1.21209C10.8387 1.3879 10.9375 1.62636 10.9375 1.875V2.1875H12.5V1.875C12.5 1.62636 12.5988 1.3879 12.7746 1.21209C12.9504 1.03627 13.1889 0.9375 13.4375 0.9375C13.6861 0.9375 13.9246 1.03627 14.1004 1.21209C14.2762 1.3879 14.375 1.62636 14.375 1.875V2.1875H16.25C16.4986 2.1875 16.7371 2.28627 16.9129 2.46209C17.0887 2.6379 17.1875 2.87636 17.1875 3.125ZM15.3125 4.0625H14.375V4.375C14.375 4.62364 14.2762 4.8621 14.1004 5.03791C13.9246 5.21373 13.6861 5.3125 13.4375 5.3125C13.1889 5.3125 12.9504 5.21373 12.7746 5.03791C12.5988 4.8621 12.5 4.62364 12.5 4.375V4.0625H10.9375V4.375C10.9375 4.62364 10.8387 4.8621 10.6629 5.03791C10.4871 5.21373 10.2486 5.3125 10 5.3125C9.75136 5.3125 9.5129 5.21373 9.33709 5.03791C9.16127 4.8621 9.0625 4.62364 9.0625 4.375V4.0625H7.5V4.375C7.5 4.62364 7.40123 4.8621 7.22541 5.03791C7.0496 5.21373 6.81114 5.3125 6.5625 5.3125C6.31386 5.3125 6.0754 5.21373 5.89959 5.03791C5.72377 4.8621 5.625 4.62364 5.625 4.375V4.0625H4.6875V15.625C4.6875 15.8736 4.78627 16.1121 4.96209 16.2879C5.1379 16.4637 5.37636 16.5625 5.625 16.5625H14.375C14.6236 16.5625 14.8621 16.4637 15.0379 16.2879C15.2137 16.1121 15.3125 15.8736 15.3125 15.625V4.0625Z" fill="#656565" />
      </svg>
    ),
    text: "Weekly reports",
    route: "/progress/weekly",
  },
  {
    icon: (color = "black") => (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.788 8.08746L12.538 1.83746C12.4069 1.70624 12.2399 1.61685 12.058 1.58059C11.8761 1.54433 11.6876 1.56283 11.5162 1.63376C11.3448 1.70468 11.1984 1.82483 11.0953 1.97902C10.9922 2.1332 10.9372 2.3145 10.9372 2.49996V5.37027C8.9247 5.61402 6.74501 6.61168 4.94111 8.14136C2.66298 10.0742 1.24423 12.5703 0.945795 15.1726C0.915562 15.4338 0.968432 15.6978 1.09689 15.9272C1.22534 16.1565 1.42284 16.3396 1.66131 16.4502C1.89977 16.5609 2.16705 16.5936 2.42514 16.5436C2.68324 16.4936 2.91901 16.3635 3.09892 16.1718C3.91611 15.3015 6.77079 12.5984 10.9372 12.2328V15C10.9374 15.1853 10.9924 15.3664 11.0955 15.5204C11.1985 15.6744 11.3448 15.7944 11.516 15.8653C11.6873 15.9362 11.8756 15.9548 12.0574 15.9187C12.2391 15.8826 12.4061 15.7934 12.5372 15.6625L18.7872 9.41246C18.9629 9.23678 19.0616 8.99856 19.0618 8.75012C19.0619 8.50168 18.9634 8.26334 18.788 8.08746ZM12.8122 12.7343V11.25C12.8122 11.0013 12.7134 10.7629 12.5376 10.587C12.3618 10.4112 12.1233 10.3125 11.8747 10.3125C8.04658 10.3125 5.11142 11.9968 3.29736 13.4461C3.85439 12.0273 4.83095 10.6945 6.15439 9.57183C7.91376 8.07886 10.052 7.18746 11.8747 7.18746C12.1233 7.18746 12.3618 7.08868 12.5376 6.91287C12.7134 6.73705 12.8122 6.4986 12.8122 6.24996V4.76558L16.7966 8.74996L12.8122 12.7343Z" fill="#656565" />
      </svg>

    ),
    text: "Social reports",
    route: "/settings?tab=faq",
  },
 
 
  {
    icon: (color = "black") => (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.99952 5.93749C9.19603 5.93749 8.41059 6.17575 7.74251 6.62215C7.07444 7.06854 6.55374 7.70302 6.24626 8.44534C5.93878 9.18767 5.85833 10.0045 6.01508 10.7925C6.17183 11.5806 6.55875 12.3045 7.1269 12.8726C7.69505 13.4408 8.41892 13.8277 9.20696 13.9844C9.99501 14.1412 10.8118 14.0607 11.5542 13.7533C12.2965 13.4458 12.931 12.9251 13.3774 12.257C13.8238 11.5889 14.062 10.8035 14.062 9.99999C14.0608 8.92293 13.6324 7.89034 12.8708 7.12874C12.1092 6.36714 11.0766 5.93873 9.99952 5.93749ZM9.99952 12.1875C9.56687 12.1875 9.14394 12.0592 8.78421 11.8188C8.42448 11.5785 8.1441 11.2368 7.97853 10.8371C7.81296 10.4374 7.76964 9.99757 7.85405 9.57323C7.93845 9.1489 8.14679 8.75912 8.45272 8.4532C8.75865 8.14727 9.14842 7.93893 9.57276 7.85452C9.99709 7.77012 10.4369 7.81344 10.8366 7.97901C11.2364 8.14457 11.578 8.42495 11.8184 8.78468C12.0587 9.14441 12.187 9.56735 12.187 9.99999C12.187 10.5802 11.9565 11.1366 11.5463 11.5468C11.1361 11.957 10.5797 12.1875 9.99952 12.1875ZM18.8948 8.31484C18.8684 8.18279 18.8138 8.05798 18.7348 7.94892C18.6558 7.83985 18.5542 7.74909 18.437 7.6828L16.2659 6.44452L16.2573 3.99843C16.2569 3.86271 16.2269 3.72872 16.1696 3.6057C16.1123 3.48268 16.0289 3.37358 15.9253 3.28593C15.0504 2.54568 14.043 1.97809 12.9565 1.61327C12.8326 1.57147 12.7013 1.55606 12.5711 1.56803C12.4408 1.58001 12.3145 1.6191 12.2003 1.68281L9.99952 2.91171L7.79874 1.68202C7.68436 1.61797 7.55782 1.57862 7.42729 1.56651C7.29676 1.5544 7.16513 1.5698 7.04092 1.61171C5.95417 1.97805 4.94677 2.54722 4.07217 3.28906C3.9689 3.37661 3.88581 3.48549 3.82863 3.60822C3.77145 3.73094 3.74153 3.8646 3.74092 3.99999L3.72999 6.44843L1.56202 7.68359C1.44476 7.75012 1.34323 7.84117 1.26436 7.95051C1.18549 8.05985 1.13113 8.18492 1.10499 8.31718C0.884275 9.42899 0.884275 10.5733 1.10499 11.6851C1.13134 11.8171 1.18579 11.9419 1.26465 12.0509C1.34352 12.16 1.44494 12.2508 1.56202 12.3172L3.73545 13.5555L3.74405 16.0016C3.74452 16.1373 3.77446 16.2713 3.83178 16.3943C3.88911 16.5173 3.97246 16.6264 4.07608 16.7141C4.951 17.4543 5.95839 18.0219 7.04483 18.3867C7.16876 18.4285 7.30007 18.4439 7.43031 18.4319C7.56055 18.42 7.68685 18.3809 7.80108 18.3172L9.99952 17.0883L12.198 18.318C12.3123 18.382 12.4389 18.4214 12.5694 18.4335C12.6999 18.4456 12.8316 18.4302 12.9558 18.3883C14.0425 18.0219 15.0499 17.4528 15.9245 16.7109C16.0278 16.6234 16.1109 16.5145 16.1681 16.3918C16.2252 16.269 16.2552 16.1354 16.2558 16L16.2667 13.5516L18.4394 12.3164C18.5566 12.2499 18.6581 12.1588 18.737 12.0495C18.8159 11.9401 18.8703 11.8151 18.8964 11.6828C19.1166 10.5709 19.1161 9.42654 18.8948 8.31484ZM17.1269 10.907L15.0269 12.1008C14.8777 12.1854 14.7547 12.3094 14.6714 12.4594C14.6292 12.5375 14.5847 12.6101 14.5386 12.6844C14.446 12.8322 14.3965 13.0029 14.3956 13.1773L14.3847 15.5469C13.8793 15.9272 13.3258 16.239 12.7386 16.4742L10.6175 15.2875C10.4776 15.2092 10.32 15.168 10.1597 15.168H10.137C10.048 15.168 9.95733 15.168 9.86827 15.168C9.70073 15.164 9.53517 15.2047 9.38858 15.2859L7.26514 16.4703C6.67698 16.2363 6.12221 15.9258 5.61514 15.5469L5.60655 13.1844C5.60582 13.0097 5.55631 12.8387 5.46358 12.6906C5.41827 12.6172 5.37295 12.5414 5.33077 12.4656C5.24743 12.3166 5.12473 12.1934 4.97608 12.1094L2.87452 10.9086C2.79288 10.3061 2.79288 9.69542 2.87452 9.09296L4.97452 7.89921C5.12347 7.81465 5.24641 7.6909 5.32999 7.5414C5.37217 7.46327 5.41671 7.38984 5.4628 7.31562C5.55539 7.16779 5.6049 6.99707 5.60577 6.82265L5.61436 4.45312C6.11995 4.07388 6.67344 3.76312 7.26046 3.5289L9.38155 4.71562C9.52806 4.79781 9.69408 4.83885 9.86202 4.83437C9.95108 4.83437 10.0417 4.83437 10.1308 4.83437C10.2983 4.83833 10.4639 4.79761 10.6105 4.7164L12.7339 3.52968C13.3221 3.76371 13.8768 4.07419 14.3839 4.45312L14.3925 6.81562C14.3932 6.99031 14.4427 7.16132 14.5355 7.30937C14.5808 7.3828 14.6261 7.45859 14.6683 7.53437C14.7516 7.68339 14.8743 7.80663 15.023 7.89062L17.1245 9.08827C17.2072 9.69165 17.208 10.3034 17.1269 10.907Z" fill="#656565" />
      </svg>

    ),
    text: "Settings",
    route: "/setting",
  },
];

export const ProgressInfluencesList = [
  {
    title: "Days exercised",
    daysTracked: 17,
    percent: "70",
    unit: "%",
    type: "Completion against target",
  },
  {
    title: "Blocked digital distractions",
    daysTracked: 10,
    percent: "30",
    unit: "%",
    type: "Completion against target",
  },
  {
    title: "8H of time in bed",
    daysTracked: 40,
    percent: "38",
    type: "Completion against target",
  },
  {
    title: "Deep Work",
    daysTracked: 35,
    percent: "4.5",
    unit: "h",
    type: "Monthly Average",
  },
  {
    title: "Blocked digital distractions",
    daysTracked: 10,
    percent: "30",
    unit: "%",
    type: "Completion against target",
  },
  {
    title: "Time spent meditating",
    daysTracked: 20,
    percent: "300",
    unit: "min",
    type: "Monthly Average",
  },
  {
    title: "Time in personal conversation",
    daysTracked: 35,
    percent: "45",
    unit: "min",
    type: "Avg. time per conversation",
  },
  {
    title: "Wake up around between 05:00 and 05:30",
    daysTracked: 35,
    percent: "72",
    unit: "%",
    type: "Average daily completion",
  },
  {
    title: "Coaching sessions",
    daysTracked: 47,
    percent: "54",
    unit: "%",
    type: "Completion against target",
  },
  {
    title: "Time in personal conversation",
    daysTracked: 35,
    percent: "45",
    unit: "min",
    type: "Avg. time per conversation",
  },
];

export const weekDays = [
  { day: "MONDAY" },
  { day: "TUESDAY" },
  { day: "WEDNESDAY" },
  { day: "THURSDAY" },
  { day: "FRIDAY" },
  { day: "SATURDAY" },
  { day: "SUNDAY" },
];

export const blogdata = [
  {
    id: 1,
    img: "",
    title: "Keeping focus in extraordinary circumstances",
    desc: "Sometimes the world throws us a fex curve balls and our ability to stay on task can be tested. In this post ...",
  },
  {
    id: 2,
    img: "",
    title: "Keeping focus in extraordinary circumstances",
    desc: "Sometimes the world throws us a fex curve balls and our ability to stay on task can be tested. In this post ...",
  },
  {
    id: 3,
    img: "",
    title: "Keeping focus in extraordinary circumstances",
    desc: "Sometimes the world throws us a fex curve balls and our ability to stay on task can be tested. In this post ...",
  },
  {
    id: 4,
    img: "",
    title: "Keeping focus in extraordinary circumstances",
    desc: "Sometimes the world throws us a fex curve balls and our ability to stay on task can be tested. In this post ...",
  },
];

export const isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().includes('firefox');